import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";

import { fetchMedias } from "../../features/admin/MediaSlice";
import { toast } from "react-toastify";
import ApiCustom from "../../utils/ApiCustom";
import { formatDate } from "../../utils/helps";
import BusinessFieldSelection from "../BusinessFieldSelection";
import UserSelection from "../UserSelection";
import {
  PlusIcon,
  TrashIcon,
  PhotoIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import ConfirmDeleteCompanyUserModal from "../../components/ConfirmDeleteCompanyUserModal";
import ConfirmMakeCompanyUserRepresentModal from "../../components/ConfirmMakeCompanyUserRepresentModal";
import AvatarImageModal from "./AvatarImageModal";
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/solid";
import apiCustom from "../../utils/ApiCustom";

const partnerSchema = Yup.object().shape({
  companyName: Yup.string().trim().required("Tên đơn vị không được để trống"),
  userEmail: Yup.string()
    .trim()
    .email("Email không đúng định dạng")
    .required("Email không được để trống"),
  userPhone: Yup.string()
    .trim()
    .matches(
      /^(0[3|5|7|8|9])+([0-9]{8})\b/,
      "Số điện thoại không đúng định dạng"
    )
    .required("Số điện thoại không được để trống"),
  businessFieldIds: Yup.array()
    .of(Yup.object())
    .min(1, "Phải chọn ít nhất 1 lĩnh vực")
    .required("Phải chọn ít nhất 1 lĩnh vực"),
  // businessField: Yup.string()
  //   .trim()
  //   .required("Lĩnh vực kinh doanh không được để trống"),
  businessAddress: Yup.string()
    .trim()
    .required("Địa chỉ đơn vị không được để trống"),
  websiteOrHotline: Yup.string().nullable(),
  hotline: Yup.string().nullable().matches(/^\d*$/, "Hotline không hợp lệ"),
  taxCode: Yup.string().nullable().matches(/^\d*$/, "Mã số thuế không hợp lệ"),
  // images: Yup.mixed().nullable(),
});

const userIdSchema = Yup.object().shape({
  userId: Yup.number()
    .typeError("Vui lòng chọn người đại diện")
    .integer("Vui lòng chọn người đại diện")
    .positive("Vui lòng chọn người đại diện")
    .required("Vui lòng chọn người đại diện"),
});

const companyFieldLabels = {
  userFullName: "Họ và tên",
  yearOfBirth: "Ngày sinh",
  userEmail: "Email",
  hometown: "Nơi sinh",
  userPhone: "Số điện thoại",
  companyName: "Tên đơn vị",
  // businessField: "Lĩnh vực kinh doanh",
  businessFieldIds: "Lĩnh vực kinh doanh",
  businessAddress: "Địa chỉ đơn vị",
  websiteOrHotline: "Website",
  hotline: "Hotline",
  taxCode: "Mã số thuế",
};

const companyRepresentFieldLabels = {
  userFullName: "Họ và tên",
  userEmail: "Email",
  userPhone: "Số điện thoại",
  userAddress: "Địa chỉ",
  placeOfBirth: "Nơi sinh",
  dateOfBirth: "Ngày sinh",
  idCard: "Số căn cước",
  userAvatar: "Ảnh đại diện",
  position: "Chức vụ tại đơn vị",
};

const PartnerModal = ({ companyId, onClose, onSubmit, representList }) => {
  const [formData, setFormData] = useState({
    userFullName: "",
    yearOfBirth: "",
    userEmail: "",
    images: "",
    hometown: "",
    userPhone: "",
    companyName: "",
    businessField: "",
    businessFieldIds: [],
    businessAddress: "",
    websiteOrHotline: "",
    hotline: "",
    userMember: [],
    nonEditable: true,
    taxCode: "",
  });
  const [businessField, setBusinessField] = useState([]);
  const [companyRepresent, setCompanyRepresent] = useState(null);
  const [userMemberSelected, setUserMemberSelected] = useState([]);
  const [userMember, setUserMember] = useState([]);
  const [userMemberData, setUserMemberData] = useState([]);

  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState("");
  const [hasNewImage, setHasNewImage] = useState(false);
  const currentUserId = localStorage.getItem("userId");
  const [selectedBusinessFields, setSelectedBusinessFields] = useState([]);
  const dispatch = useDispatch();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);
  const [isMakeRepresentOpen, setIsMakeRepresentOpen] = useState(false);
  const [companyUserBeDeleted, setCompanyUserBeDeleted] = useState({});
  const [companyUserMadeRepresent, setCompanyUserMadeRepresent] = useState({});
  const [lockUpdate, setLockUpdate] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    getBusinessField();
    if (companyId) {
      getCompany();
    }
  }, []);

  const getCompany = () => {
    ApiCustom.get(`company-show-by-id/${companyId}`)
      .then((res) => {
        setCompany(res.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const getBusinessField = () => {
    ApiCustom.get(`categories/public?t=company`)
      .then((res) => {
        setBusinessField(res.data?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const getCompanyRePresent = () => {
    const representTation = company?.users.find(
      (e) => e.CompaniesHasUsers.isUserRepresentOfCompany
    );
    return representTation;
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteOpen(false);
  };

  const handleDeleteCompanyUser = () => {
    setUserMember(
      userMember.filter((e) => e.value != companyUserBeDeleted.value)
    );
    if (formData.userId == companyUserBeDeleted.value.id) {
      setFormData((prev) => ({
        ...prev,
        userId: -1,
      }));

      setCompanyRepresent(null);
    }

    setUserMemberData((prev) => [
      ...userMemberData.filter((e) => e?.id != companyUserBeDeleted?.value?.id),
    ]);

    setIsDeleteOpen(false);
  };

  const handleOpenLogoModal = () => {
    dispatch(fetchMedias());
    setIsLogoModalOpen(true);
  };

  const handleCloseLogoModal = () => {
    setIsLogoModalOpen(false);
  };

  const handlePressLogoImage = (media) => {
    setIsLogoModalOpen(false);
    setImagePreview(media.url);
    setHasNewImage(true);
    setFormData({ ...formData, userAvatar: media.url, logoId: media?.id });
  };

  const handleCloseMadeRepresentModal = () => {
    setIsMakeRepresentOpen(false);
  };

  const handleMakeRepresentCompanyUser = () => {
    // if (company?.id) {
    setCompanyRepresent(companyUserMadeRepresent?.value);
    // }

    const tmpUserMemberData = userMemberData.map((e) => {
      if (
        e.id == companyUserMadeRepresent?.value?.id &&
        e.isUserRepresentOfCompany != null
      ) {
        e.isUserRepresentOfCompany = true;
      } else {
        e.isUserRepresentOfCompany = false;
      }
      return e;
    });
    setUserMemberData(tmpUserMemberData);

    setFormData((prev) => ({
      ...prev,
      userId: companyUserMadeRepresent?.value?.id,
    }));

    setIsMakeRepresentOpen(false);
  };

  useEffect(() => {
    if (company) {
      if (company?.id) {
        setCompanyRepresent(getCompanyRePresent() ?? null);
        setSelectedBusinessFields(
          company.businessFields.map((e) => ({
            value: e.id,
            label: e.name,
          }))
        );

        setUserMember(
          company?.users?.map((e) => ({
            label: e?.userFullName,
            value: e,
          }))
        );

        setUserMemberData(
          company?.users?.map((e) => ({
            id: e?.id,
            userPosition: e?.CompaniesHasUsers?.userPosition,
            isUserRepresentOfCompany:
              e?.CompaniesHasUsers?.isUserRepresentOfCompany,
          }))
        );

        setFormData((prevFormData) => ({
          ...prevFormData,
          businessFieldIds: company.businessFields.map((e) => ({
            value: e.id,
            label: e.name,
          })),
          userId:
            company?.users?.find(
              (e) => e?.CompaniesHasUsers?.isUserRepresentOfCompany
            )?.id ?? -1,
          nonEditable: company.nonEditable ?? true,
        }));

        const lock = company.nonEditable ?? true;
        const companyRepresentId =
          company?.users?.find(
            (e) => e?.CompaniesHasUsers?.isUserRepresentOfCompany
          )?.id ?? -1;
        if (currentUserId == companyRepresentId && currentUserId != 1) {
          setLockUpdate(lock);
        } else {
          setLockUpdate(hasPermission("COMPANY_UPDATE") ? lock : true);
        }
      }

      const { userId, ...newCompanyData } = company;
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...newCompanyData,
      }));
      // if (newCompanyData.images) {
      //   setImagePreview(
      //     `${process.env.REACT_APP_API_URL}/media/${newCompanyData.images}`
      //   );
      // }
    }
  }, [company]);

  const getImageUrl = () => {
    if (hasNewImage) {
      return imagePreview;
    } else if (company && company.userAvatar) {
      return `${process.env.REACT_APP_API_URL}media/${company.userAvatar}`;
    }
    return "";
  };

  const getLogoImageUrl = () => {
    if (hasNewImage) {
      return imagePreview;
    } else if (company && company.userAvatar) {
      return company.userAvatar;
    }
    return "";
  };

  const handleUserSelectorChange = async (userSelected) => {
    setUserMemberSelected(userSelected);
  };

  const handleBusinessFieldSelectorChange = async (selectedBusinessField) => {
    try {
      setErrors((prev) => ({ ...prev, ["businessFieldIds"]: undefined }));

      setSelectedBusinessFields(selectedBusinessField);
      setFormData((prev) => ({
        ...prev,
        businessFieldIds: selectedBusinessField,
      }));

      await Yup.reach(partnerSchema, "businessFieldIds").validate(
        selectedBusinessField
      );
    } catch (validationError) {
      setErrors((prev) => ({
        ...prev,
        ["businessFieldIds"]: validationError.message,
      }));
    }
  };

  const handleLockUpdate = async ({ useToast = true }) => {
    try {
      const response = await apiCustom.put(
        `/company-lock-update`,
        {
          id: company.id,
          nonEditable: !lockUpdate,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setLockUpdate(!lockUpdate);
        setFormData((prev) => ({ ...prev, nonEditable: !lockUpdate }));

        if (useToast) {
          if (!lockUpdate) {
            toast.success("Đã khoá thông tin hội viên!");
          } else {
            toast.success("Đã mở khoá thông tin hội viên!");
          }
        }
      }
    } catch (error) {
      toast.error("Đã xảy ra lỗi!");
    } finally {
      // dispatch(fetchCompanies());
      // onClose();
    }
  };

  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    let newValue = value;

    if (name === "images" && files[0]) {
      const file = files[0];

      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Hình ảnh phải có kích thước nhỏ hơn hoặc bằng 2Mb",
        }));
        return;
      }

      newValue = file;
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setHasNewImage(true);
      };
      reader.readAsDataURL(file);
    }

    if (name == "userId" && value > -1) {
      const tmpUserMemberData = userMemberData.map((e) => {
        if (e.id == parseInt(value) && e.isUserRepresentOfCompany != null) {
          e.isUserRepresentOfCompany = true;
        } else {
          e.isUserRepresentOfCompany = false;
        }
        return e;
      });

      if (!userMember.map((e) => e.value.id).includes(parseInt(value))) {
        const item = representList.find((e) => e.id == value);
        setCompanyRepresent(item);
        setUserMember([
          ...userMember,
          {
            label: item.userFullName,
            value: item,
          },
        ]);

        setUserMemberData((prev) => [
          ...tmpUserMemberData,
          {
            id: item.id,
            userPosition: "",
            isUserRepresentOfCompany: true,
          },
        ]);
      } else {
        setCompanyRepresent(
          userMember.find((e) => e?.value?.id == value)?.value
        );
      }
    }

    setFormData((prev) => ({ ...prev, [name]: newValue }));

    try {
      let validateSchema;
      validateSchema = partnerSchema.concat(userIdSchema);

      await Yup.reach(validateSchema, name).validate(newValue);
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    } catch (validationError) {
      setErrors((prev) => ({ ...prev, [name]: validationError.message }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const backupBusinessFieldIds = formData.businessFieldIds;
    try {
      formData.position = "";
      let validateSchema;
      validateSchema = partnerSchema.concat(userIdSchema);

      await validateSchema.validate(formData, { abortEarly: false });

      formData["companyName"] = formData["companyName"].toUpperCase();
      formData.businessFieldIds = formData.businessFieldIds.map((e) =>
        parseInt(e.value)
      );

      formData["userMemberData"] = userMemberData;
      if (company?.id) {
        const { userId, ...updateFormData } = formData;

        ApiCustom.put(`/company-update-by-id/${company.id}`, updateFormData)
          .then(async (res) => {
            if (res.status === 200) {
              await handleLockUpdate({ useToast: false });
            }
            toast.success("Cập nhật hội viên thành công");
            onSubmit();
            onClose();
          })
          .catch((error) => {
            formData.businessFieldIds = backupBusinessFieldIds;
            if (error.response?.status === 422) {
              if (
                !Object.keys(error?.response?.data?.messages).includes(
                  "representUser"
                )
              ) {
                setErrors(error?.response?.data?.messages);
              }
              toast.error(Object.values(error?.response?.data?.messages)[0]);
            }
          });
      } else {
        // await dispatch(createPartner(formData)).unwrap();
        ApiCustom.post(`/company-create`, formData)
          .then((res) => {
            const representDataUpdate = {
              id: formData.userId,
              companyId: res?.data?.data?.id,
            };

            ApiCustom.put(`/user-update-company`, representDataUpdate)
              .then((res) => {
                onSubmit();
                toast.success("Thêm hội viên thành công");
                onClose();
              })
              .catch((error) => {
                formData.businessFieldIds = backupBusinessFieldIds;
                if (error.response?.status === 422) {
                  if (
                    !Object.keys(error?.response?.data?.messages).includes(
                      "representUser"
                    )
                  ) {
                    setErrors(error?.response?.data?.messages);
                  } else {
                    toast.error(
                      Object.values(error?.response?.data?.messages)[0]
                    );
                  }
                }
              });
          })
          .catch((error) => {
            formData.businessFieldIds = backupBusinessFieldIds;
            if (error.response?.status === 422) {
              if (
                !Object.keys(error?.response?.data?.messages).includes(
                  "representUser"
                )
              ) {
                setErrors(error?.response?.data?.messages);
              } else {
                toast.error(Object.values(error?.response?.data?.messages)[0]);
              }
            }
          });
      }
    } catch (error) {
      formData.businessFieldIds = backupBusinessFieldIds;
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};

        if (error.inner.length > 0) {
          error.inner.forEach((validationError) => {
            formErrors[validationError.path] = validationError.message;
          });
        } else if (error.path) {
          formErrors[error.path] = error.message;
        }

        setErrors(formErrors);
        if (formErrors.userId) {
          toast.error(formErrors.userId);
        }
        return;
      }

      const responseMessages = error?.response?.data?.messages;
      if (responseMessages && typeof responseMessages === "object") {
        if (!Object.keys(responseMessages).includes("representUser")) {
          setErrors(responseMessages);
        }

        const firstMessage = Object.values(responseMessages)[0];
        if (firstMessage) {
          toast.error(firstMessage);
        }
      } else {
        toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
      }
    }
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions).map((p) => p.permissionSlug)
      : [];
  };

  const hasPermission = (requiredPermission) => {
    if (currentUserId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const handleSendApprove = async (e) => {
    e.preventDefault();
    // if (!company?.images || company?.images == "") {
    //   toast.error("Vui lòng cập nhật logo đơn vị");
    //   return;
    // }
    try {
      ApiCustom.put(
        `/users/${company.id}/send-approve`,
        {
          approvalStatus: "Gửi duyệt",
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((res) => {
          toast.success("Gửi duyệt thành công");
          onClose();
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
      toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="">
          <div className="p-6 rounded-lg sticky top-0 bg-base-100 z-10">
            <div className="flex justify-between items-center ">
              <h2 className="text-2xl font-bold ">
                {company?.id
                  ? "Chỉnh sửa thông tin hội viên"
                  : "Thêm hội viên mới"}
              </h2>
              <button
                onClick={onClose}
                className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>
          </div>

          <form className="space-y-8">
            <div className="px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-6">
                  <div className="space-y-4">
                    {/* Company section */}
                    {company?.id && (
                      <h3 className="font-bold text-center py-0 my-0">
                        Thông tin đơn vị
                      </h3>
                    )}
                    {["companyName"].map((key) => (
                      <div key={key}>
                        <label className="block text-sm font-medium  mb-1">
                          {companyFieldLabels[key]}
                          <i className="text-red-600"> *</i>
                        </label>
                        <input
                          style={{ textTransform: "uppercase" }}
                          disabled={lockUpdate}
                          type="text"
                          name={key}
                          value={formData[key]}
                          onChange={handleChange}
                          className={`w-full p-2 border rounded-md focus:ring-2 ${
                            errors[key] ? "border-red-500" : "border-gray-300"
                          } focus:ring-blue-500 focus:border-transparent`}
                        />
                        {errors[key] && (
                          <p className="mt-1 text-sm text-red-600">
                            {errors[key]}
                          </p>
                        )}
                      </div>
                    ))}

                    {["userPhone", "userEmail"].map((key) => (
                      <div key={key}>
                        <label className="block text-sm font-medium  mb-1">
                          {companyFieldLabels[key]}
                          <i className="text-red-600"> *</i>
                        </label>
                        <input
                          type="text"
                          disabled={lockUpdate}
                          name={key}
                          value={formData[key]}
                          onChange={handleChange}
                          className={`w-full p-2 border rounded-md focus:ring-2 ${
                            errors[key] ? "border-red-500" : "border-gray-300"
                          } focus:ring-blue-500 focus:border-transparent`}
                        />
                        {errors[key] && (
                          <p className="mt-1 text-sm text-red-600">
                            {errors[key]}
                          </p>
                        )}
                      </div>
                    ))}

                    {company?.id && (
                      <>
                        {["businessAddress"].map((key) => (
                          <div key={key}>
                            <label className="block text-sm font-medium  mb-1">
                              {companyFieldLabels[key]}
                              {["businessAddress"].includes(key) && (
                                <i className="text-red-600"> *</i>
                              )}
                            </label>
                            <input
                              type="text"
                              name={key}
                              disabled={lockUpdate}
                              value={formData[key]}
                              onChange={handleChange}
                              className={`w-full p-2 border rounded-md focus:ring-2 ${
                                errors[key]
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:ring-blue-500 focus:border-transparent`}
                            />
                            {errors[key] && (
                              <p className="mt-1 text-sm text-red-600">
                                {errors[key]}
                              </p>
                            )}
                          </div>
                        ))}

                        {["taxCode"].map((key) => (
                          <div key={key}>
                            <label className="block text-sm font-medium  mb-1">
                              {companyFieldLabels[key]}
                            </label>
                            <input
                              type="text"
                              name={key}
                              disabled={lockUpdate}
                              value={
                                formData[key] !== "null" ? formData[key] : ""
                              }
                              onChange={handleChange}
                              className={`w-full p-2 border rounded-md focus:ring-2 ${
                                errors[key]
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:ring-blue-500 focus:border-transparent`}
                            />
                            {errors[key] && (
                              <p className="mt-1 text-sm text-red-600">
                                {errors[key]}
                              </p>
                            )}
                          </div>
                        ))}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {["websiteOrHotline", "hotline"].map((key) => (
                            <div key={key}>
                              <label className="block text-sm font-medium  mb-1">
                                {companyFieldLabels[key]}
                                {["businessAddress"].includes(key) && (
                                  <i className="text-red-600"> *</i>
                                )}
                              </label>
                              <input
                                type="text"
                                name={key}
                                disabled={lockUpdate}
                                value={formData[key]}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded-md focus:ring-2 ${
                                  errors[key]
                                    ? "border-red-500"
                                    : "border-gray-300"
                                } focus:ring-blue-500 focus:border-transparent`}
                              />
                              {errors[key] && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors[key]}
                                </p>
                              )}
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {company?.id && (
                      <>
                        <BusinessFieldSelection
                          disable={lockUpdate}
                          padding={2}
                          options={businessField.map((e) => ({
                            value: e.id,
                            label: e.name,
                          }))}
                          onChange={handleBusinessFieldSelectorChange}
                          error={errors.businessFieldIds != null}
                          selectedFields={selectedBusinessFields}
                        />

                        {errors.businessFieldIds && (
                          <span className="text-red-500 text-sm">
                            {errors.businessFieldIds}
                          </span>
                        )}
                      </>
                    )}

                    {!company?.id && (
                      <div className="form-control mt-3">
                        <div className="block text-sm font-medium mb-1">
                          Người đại diện<i className="text-red-600"> *</i>
                        </div>
                        <select
                          name="userId"
                          value={formData.userId}
                          onChange={handleChange}
                          className={`w-full p-2 border rounded-md min-h-10 ${
                            errors.userId ? "border-red-500" : "border-gray-300"
                          } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        >
                          <option value={-1}>Chọn người đại diện</option>
                          {representList?.length > 0 &&
                            representList?.map((item, index) => (
                              <option key={index} value={item.id}>
                                {item?.userFullName}
                              </option>
                            ))}
                        </select>

                        {errors.userId && (
                          <p className="text-red-500 text-sm">
                            {errors.userId}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {!company?.id && (
                  <div className="space-y-6">
                    <div className="space-y-4">
                      {["businessAddress"].map((key) => (
                        <div key={key}>
                          <label className="block text-sm font-medium  mb-1">
                            {companyFieldLabels[key]}
                            {["businessAddress"].includes(key) && (
                              <i className="text-red-600"> *</i>
                            )}
                          </label>
                          <input
                            type="text"
                            name={key}
                            disabled={lockUpdate}
                            value={formData[key]}
                            onChange={handleChange}
                            className={`w-full p-2 border rounded-md focus:ring-2 ${
                              errors[key] ? "border-red-500" : "border-gray-300"
                            } focus:ring-blue-500 focus:border-transparent`}
                          />
                          {errors[key] && (
                            <p className="mt-1 text-sm text-red-600">
                              {errors[key]}
                            </p>
                          )}
                        </div>
                      ))}

                      {["taxCode"].map((key) => (
                        <div key={key}>
                          <label className="block text-sm font-medium  mb-1">
                            {companyFieldLabels[key]}
                          </label>
                          <input
                            type="text"
                            name={key}
                            disabled={lockUpdate}
                            value={formData[key]}
                            onChange={handleChange}
                            className={`w-full p-2 border rounded-md focus:ring-2 ${
                              errors[key] ? "border-red-500" : "border-gray-300"
                            } focus:ring-blue-500 focus:border-transparent`}
                          />
                          {errors[key] && (
                            <p className="mt-1 text-sm text-red-600">
                              {errors[key]}
                            </p>
                          )}
                        </div>
                      ))}

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {["websiteOrHotline", "hotline"].map((key) => (
                          <div key={key}>
                            <label className="block text-sm font-medium  mb-1">
                              {companyFieldLabels[key]}
                              {["businessAddress"].includes(key) && (
                                <i className="text-red-600"> *</i>
                              )}
                            </label>
                            <input
                              type="text"
                              name={key}
                              disabled={lockUpdate}
                              value={formData[key]}
                              onChange={handleChange}
                              className={`w-full p-2 border rounded-md focus:ring-2 ${
                                errors[key]
                                  ? "border-red-500"
                                  : "border-gray-300"
                              } focus:ring-blue-500 focus:border-transparent`}
                            />
                            {errors[key] && (
                              <p className="mt-1 text-sm text-red-600">
                                {errors[key]}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="form-control">
                        <BusinessFieldSelection
                          disable={lockUpdate}
                          padding={2}
                          options={businessField.map((e) => ({
                            value: e.id,
                            label: e.name,
                          }))}
                          onChange={handleBusinessFieldSelectorChange}
                          error={errors.businessFieldIds != null}
                          selectedFields={selectedBusinessFields}
                        />

                        {errors.businessFieldIds && (
                          <span className="text-red-500 text-sm">
                            {errors.businessFieldIds}
                          </span>
                        )}
                      </div>

                      {/* <div className="form-control mt-3">
                      <div className="block text-sm font-medium  mb-1">
                        Lĩnh vực kinh doanh<i className="text-red-600"> *</i>
                      </div>
                      <select
                        name="businessField"
                        value={formData.businessField}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded-md ${
                          errors.businessField
                            ? "border-red-500"
                            : "border-gray-300"
                        } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      >
                        <option value={0}>Chọn lĩnh vực kinh doanh</option>
                        {businessField?.length > 0 &&
                          businessField?.map((item, index) => (
                            <option key={index} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                      </select>

                      {errors.businessField && (
                        <p className="text-red-500 text-sm">
                          {errors.businessField}
                        </p>
                      )}
                    </div> */}
                    </div>
                  </div>
                )}

                {company?.id && (
                  <div className="space-y-6">
                    <div className="space-y-4">
                      {/* User section */}
                      <h3 className="font-bold text-center py-0 my-0">
                        Thông tin người đại diện
                      </h3>
                      {companyRepresent != null && (
                        <>
                          {[
                            "userFullName",
                            "userPhone",
                            "userEmail",
                            "userAddress",
                          ].map((key) => (
                            <div key={key}>
                              <label className="block text-sm font-medium  mb-1">
                                {companyRepresentFieldLabels[key]}
                              </label>
                              <input
                                type="text"
                                disabled
                                value={
                                  ["dateOfBirth"].includes(key)
                                    ? formatDate(companyRepresent[key])
                                    : companyRepresent[key]
                                }
                                onChange={handleChange}
                                className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                              />
                            </div>
                          ))}

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {["idCard", "dateOfBirth"].map((key) => (
                              <div key={key}>
                                <label className="block text-sm font-medium  mb-1">
                                  {companyRepresentFieldLabels[key]}
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  value={
                                    ["dateOfBirth"].includes(key)
                                      ? formatDate(companyRepresent[key])
                                      : companyRepresent[key]
                                  }
                                  onChange={handleChange}
                                  className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                />
                              </div>
                            ))}
                          </div>

                          {["placeOfBirth"].map((key) => (
                            <div key={key}>
                              <label className="block text-sm font-medium  mb-1">
                                {companyRepresentFieldLabels[key]}
                              </label>
                              <input
                                type="text"
                                disabled
                                value={
                                  ["dateOfBirth"].includes(key)
                                    ? formatDate(companyRepresent[key])
                                    : companyRepresent[key]
                                }
                                onChange={handleChange}
                                className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                              />
                            </div>
                          ))}

                          <div key={"position"}>
                            <label className="block text-sm font-medium  mb-1">
                              {companyRepresentFieldLabels["position"]}
                            </label>
                            <input
                              type="text"
                              disabled
                              value={
                                companyRepresent?.CompaniesHasUsers
                                  ?.userPosition
                              }
                              onChange={handleChange}
                              className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                            />
                          </div>
                        </>
                      )}

                      {companyRepresent == null && (
                        <div className="w-full py-36 flex justify-center">
                          <div className="w-full flex-col justify-center items-center">
                            <h4 className="text-gray-500 mb-5 text-center">
                              Chưa có người đại diện
                            </h4>
                            <div className="form-control mt-3 w-80 m-auto">
                              <select
                                name="userId"
                                disabled={lockUpdate}
                                value={formData.userId}
                                onChange={handleChange}
                                className={`p-2.5 border rounded-md ${
                                  errors.userId
                                    ? "border-red-500"
                                    : "border-gray-300"
                                } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                              >
                                <option value={-1}>Chọn người đại diện</option>
                                {representList?.length > 0 &&
                                  representList?.map((item, index) => (
                                    <option key={index} value={item.id}>
                                      {item?.userFullName}
                                    </option>
                                  ))}
                              </select>

                              {errors.userId && (
                                <p className="text-red-500 text-sm">
                                  {errors.userId}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/*Member list section*/}
              <div className="border-t pt-3 mt-6 mb-8">
                <div className="space-y-4">
                  <div className="grid max-sm:grid-cols-1 grid-cols-2 gap-4">
                    <h2 className="text-xl font-semibold">
                      Danh sách thành viên trong đơn vị
                    </h2>
                    <div className="flex max-sm:justify-between">
                      <UserSelection
                        disable={lockUpdate}
                        options={representList
                          .filter(
                            (e) =>
                              !userMember
                                .map((e) => e?.value?.id)
                                .includes(e?.id)
                          )
                          .map((e) => ({
                            label: e.userFullName,
                            value: e,
                          }))}
                        onChange={handleUserSelectorChange}
                        // error={false}
                        selectedUsers={userMemberSelected}
                      />
                      <div
                        onClick={
                          lockUpdate
                            ? null
                            : (e) => {
                                e.preventDefault();
                                setUserMemberData((prev) => [
                                  ...userMemberData,
                                  ...userMemberSelected.map((item) => ({
                                    id: item.value.id,
                                    userPosition: "",
                                    isUserRepresentOfCompany: false,
                                  })),
                                ]);
                                setUserMember((prev) => [
                                  ...prev,
                                  ...userMemberSelected,
                                ]);
                                setUserMemberSelected([]);
                              }
                        }
                        className={`ml-4 flex items-center h-11 justify-center px-4 py-0 ${
                          lockUpdate
                            ? "bg-gray-200 border-gray-300"
                            : "text-white bg-green-700 hover:bg-green-800"
                        } border border-transparent rounded-md shadow-sm text-sm font-medium cursor-pointer`}
                      >
                        <PlusIcon className="w-5 h-5" />
                        <span>Thêm</span>
                      </div>
                    </div>
                  </div>

                  {userMember.length > 0 && (
                    <div className="grid gap-4 border p-4 rounded-xl shadow-sm bg-white">
                      {userMember.map((item) => (
                        <div className="grid md:grid-cols-3 gap-4">
                          <div>
                            <div className="mb-1">Họ và tên</div>
                            <div className="border rounded-lg px-4 py-2 w-full bg-gray-100">
                              {item.value.userFullName}
                            </div>
                          </div>
                          <div>
                            <div className="mb-1">Chức vụ tại đơn vị</div>
                            <input
                              type="text"
                              disabled={lockUpdate}
                              value={
                                userMemberData.find(
                                  (e) => e?.id == item?.value?.id
                                )?.userPosition ?? ""
                              }
                              onChange={(event) => {
                                event.preventDefault();

                                const tmpUserMemberData = userMemberData.map(
                                  (e) => {
                                    if (
                                      e.id == item?.value?.id &&
                                      e.userPosition != null
                                    ) {
                                      e.userPosition = event.target.value;
                                    }
                                    return e;
                                  }
                                );

                                setUserMemberData(tmpUserMemberData);

                                const tmpUserMember = userMember.map((e) => {
                                  if (
                                    e?.value?.id == item?.value?.id &&
                                    e?.value?.CompaniesHasUsers?.userPosition !=
                                      null
                                  ) {
                                    e.value.CompaniesHasUsers.userPosition =
                                      event.target.value;
                                  } else {
                                    e.value = {
                                      ...e.value,
                                      CompaniesHasUsers: {
                                        userPosition: event?.target?.value,
                                      },
                                    };
                                  }

                                  return e;
                                });

                                setUserMember(tmpUserMember);

                                if (
                                  companyRepresent != null &&
                                  item?.value?.id == companyRepresent?.id
                                ) {
                                  setCompanyRepresent((prev) => ({
                                    ...prev,
                                    CompaniesHasUsers: {
                                      ...prev.CompaniesHasUsers,
                                      userPosition: event?.target?.value,
                                    },
                                  }));
                                }
                              }}
                              className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                            />
                          </div>
                          <div className="flex items-center justify-end gap-3 pt-6">
                            <div
                              // onClick={(e) => {
                              //   e.preventDefault();
                              //   if (company?.id) {
                              //     setCompanyRepresent(item?.value);
                              //   }

                              //   const tmpUserMemberData = userMemberData.map(
                              //     (e) => {
                              //       if (
                              //         e.id == item?.value?.id &&
                              //         e.isUserRepresentOfCompany != null
                              //       ) {
                              //         e.isUserRepresentOfCompany = true;
                              //       } else {
                              //         e.isUserRepresentOfCompany = false;
                              //       }
                              //       return e;
                              //     }
                              //   );
                              //   setUserMemberData(tmpUserMemberData);

                              //   setFormData((prev) => ({
                              //     ...prev,
                              //     userId: item?.value?.id,
                              //   }));
                              // }}
                              onClick={
                                lockUpdate
                                  ? null
                                  : (e) => {
                                      e.preventDefault();
                                      if (
                                        item?.value?.id !=
                                        (companyRepresent?.id || -1)
                                      ) {
                                        setCompanyUserMadeRepresent(item);
                                        setIsMakeRepresentOpen(true);
                                      }
                                    }
                              }
                              className={`w-44 select-none px-4 py-1.5 h-10 text-center text-base ${
                                lockUpdate
                                  ? "bg-gray-200 border-gray-300 text-gray-500"
                                  : parseInt(formData?.userId) !=
                                    item?.value?.id
                                  ? "bg-blue-700 hover:bg-blue-800 text-white font-medium"
                                  : "bg-green-700 text-white font-medium"
                              } border border-transparent rounded-md shadow-sm cursor-pointer`}
                            >
                              {parseInt(formData?.userId) != item?.value?.id
                                ? "Thành viên"
                                : "Đại diện"}
                            </div>
                            <button
                              title="Xóa"
                              disabled={lockUpdate}
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                setCompanyUserBeDeleted(item);
                                setIsDeleteOpen(true);
                              }}
                              className="btn btn-outline h-10 btn-error btn-sm px-3 rounded"
                            >
                              <TrashIcon className="w-5 h-6" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {userMember.length == 0 && (
                    <div className="text-center pb-6 pt-8 text-gray-500">
                      Chưa có thành viên
                    </div>
                  )}
                </div>
              </div>

              {/* Bottom section - Image Upload and Note */}
              <div className="space-y-6 border-t pt-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium  mb-1">
                      Logo đơn vị
                    </label>
                    <div className="mt-1 flex items-center space-x-4">
                      <button
                        type="button"
                        disabled={lockUpdate}
                        onClick={handleOpenLogoModal}
                        className={`relative w-32 h-32 border-2 border-gray-300 border-dashed rounded-lg overflow-hidden ${
                          lockUpdate
                            ? "cursor-default"
                            : "cursor-pointer group hover:border-sky-500"
                        }`}
                      >
                        {getLogoImageUrl() ? (
                          <img
                            src={getLogoImageUrl()}
                            alt="Preview"
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-gray-400">
                            <PhotoIcon className="w-10 h-10 text-gray-300" />
                          </div>
                        )}

                        {!lockUpdate && (
                          <span className="absolute bottom-2 right-2 flex h-10 w-10 items-center justify-center rounded-full bg-sky-500 text-white shadow-md group-hover:bg-sky-600">
                            <PencilSquareIcon className="h-6 w-6" />
                          </span>
                        )}
                      </button>
                    </div>
                    {errors["images"] && (
                      <p className="mt-1 text-sm text-red-600">
                        {errors["images"]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer - Action Buttons */}
            <div
              className={`rounded-lg flex sticky bottom-0 bg-base-100 z-10 p-6 ${
                company ? "justify-between" : "justify-end"
              }`}
            >
              {/* Lock update section */}
              <div>
                {company?.id && hasPermission("COMPANY_UPDATE") && (
                  <div className="space-x-4 pt-4">
                    <button
                      type="button"
                      onClick={handleLockUpdate}
                      className={`px-4 py-2 border rounded-md shadow-sm text-sm font-medium flex items-center space-x-2 btn-warning hover:bg-yellow-500`}
                    >
                      {lockUpdate ? (
                        <>
                          <LockClosedIcon className="h-5 w-5" />
                          <span>Đã khoá thông tin</span>
                        </>
                      ) : (
                        <>
                          <LockOpenIcon className="h-5 w-5" />
                          <span>Khoá thông tin</span>
                        </>
                      )}
                    </button>
                  </div>
                )}
              </div>
              <div className="flex items-end justify-end space-x-4 border-t pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  {lockUpdate ? "Đóng" : "Huỷ"}
                </button>
                {!lockUpdate && (
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
                  >
                    {company?.id ? "Cập nhật" : "Thêm mới"}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      {isLogoModalOpen && (
        <AvatarImageModal
          imageableId={currentUserId}
          imageableType={"companie"}
          imageType={"logo"}
          avatarType={true}
          onClose={handleCloseLogoModal}
          onPress={handlePressLogoImage}
        />
      )}

      <ConfirmDeleteCompanyUserModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteCompanyUser}
      />

      <ConfirmMakeCompanyUserRepresentModal
        isOpen={isMakeRepresentOpen}
        onClose={handleCloseMadeRepresentModal}
        onConfirm={handleMakeRepresentCompanyUser}
      />
    </div>
  );
};

export default PartnerModal;
